import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { ThemeToggle } from './ThemeToggle';
import { BrandMark } from './BrandMark';
import './Header.css';

const navLinks = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About' },
  { to: '/book', label: 'Book' },
  { to: '/experience', label: 'Experience' },
  { to: '/podcast', label: 'Podcast', comingSoon: true },
  { to: '/blog', label: 'Blog' },
  { to: '/store', label: 'Store', comingSoon: true },
  { to: '/contact', label: 'Contact' },
];

export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="container header__container">
        <Link to="/" className="header__logo">
          <BrandMark size={28} />
          Notation of Being<span className="header__tm">™</span>
        </Link>

        <button
          className="header__menu-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
          aria-expanded={isMenuOpen}
        >
          <i className={`fas ${isMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
        </button>

        <nav className={`header__nav ${isMenuOpen ? 'header__nav--open' : ''}`}>
          <ul className="header__nav-list">
            {navLinks.map(link => (
              <li key={link.to}>
                {link.comingSoon ? (
                  <span className="header__nav-link header__nav-link--disabled">
                    {link.label} <span className="header__nav-link-badge">(Soon)</span>
                  </span>
                ) : (
                  <NavLink
                    to={link.to}
                    className={({ isActive }) =>
                      `header__nav-link ${isActive ? 'header__nav-link--active' : ''}`
                    }
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {link.label}
                  </NavLink>
                )}
              </li>
            ))}
          </ul>
        </nav>

        <div className="header__actions">
          <ThemeToggle />
        </div>
      </div>
    </header>
  );
}
